window.DocumentoAbertoItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-documento-aberto-item",
    tagName: "tr",
    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
        this.controller = options.controller;
    },

    onRender: function() {

        var tipoDocumento = this.model.get("TipoDocumento");

        if (tipoDocumento == "1") {
            this.$el.addClass("cor-1");
        } else if (tipoDocumento == "2") {

            this.$el.addClass("cor-2");
        } else {
            this.$el.addClass("cor-3");
        }

    },


    events: {
        'click td a': "showInfo"
    },
    showInfo: function(e) {

        this.controller.showView({
            region: {
                name: "documentoAbertoInfoItemViewRegion",
                selector: "#documento-aberto-info-region"
            },
            view: {
                type: DocumentoAbertoInfoItemView,
                args: {
                    model: this.model
                }
            }
        });

    }

});

window.DocumentoAbertoInfoItemView = Backbone.Marionette.ItemView.extend({
    template: "#template-documento-aberto-info",

    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    }
});


window.DocumentoAbertoView = Backbone.Marionette.CompositeView.extend({
    template: "#template-documento-aberto",
    childView: DocumentoAbertoItemView,
    childViewContainer: "#lista-documento-aberto-container",

    initialize: function(options) {
        this.app = options.app;
        this.parent = options.parent;
    },

    buildChildView: function(item, itemView) {

        var view = new itemView({
            model: item,
            app: this.app,
            parent: this,
            controller: this.parent
        });
        return view;
    },
});